import EventSourcePolyfill from 'eventsource-polyfill';

let eventSource = null;
let currentConnectionKey = null;

const onPing = () => {};

const buildConnectionKey = ({ accessToken, userId, topics }) =>
    `${accessToken}::${userId}::${topics.join('|')}`;

const closeNotificationEventSource = () => {
    if (!eventSource) {
        currentConnectionKey = null;
        return;
    }

    if (eventSource.__onSignal) {
        eventSource.removeEventListener('signal', eventSource.__onSignal);
    }

    eventSource.removeEventListener('ping', onPing);

    if (typeof eventSource.close === 'function') {
        eventSource.close();
    }

    eventSource = null;
    currentConnectionKey = null;
};

const openNotificationEventSource = ({ topics, userId, onSignal }) => {
    const accessToken = localStorage.getItem('accessToken');

    if (!accessToken || !userId || !topics || topics.length === 0) {
        return null;
    }

    const interpolatedTopics = topics.map((topic) =>
        topic.replaceAll('[USER_ID]', userId),
    );
    const connectionKey = buildConnectionKey({
        accessToken,
        userId,
        topics: interpolatedTopics,
    });

    // Keep the existing stream if nothing changed — closing it causes
    // Firefox NS_BINDING_ABORTED (red) for every unnecessary reopen.
    if (eventSource && currentConnectionKey === connectionKey) {
        if (typeof onSignal === 'function') {
            if (eventSource.__onSignal) {
                eventSource.removeEventListener(
                    'signal',
                    eventSource.__onSignal,
                );
            }

            const onSignalHandler = (event) => onSignal(event);
            eventSource.__onSignal = onSignalHandler;
            eventSource.addEventListener('signal', onSignalHandler);
        }

        return eventSource;
    }

    closeNotificationEventSource();

    const topicsStr = interpolatedTopics
        .map((topic) => `topics[]=${encodeURIComponent(topic)}`)
        .join('&');

    const xhrHeaders = {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'text/event-stream',
        'Cache-Control': 'no-cache',
        'X-Requested-With': 'XMLHttpRequest',
    };

    // bufferSizeLimit must stay large: this polyfill aborts+reconnects when
    // accumulated XHR responseText exceeds the limit (default 256KB).
    eventSource = new EventSourcePolyfill(
        `${process.env.VUE_APP_API_ENDPOINT}/api/v2/notifications/listen?${topicsStr}`,
        {
            xhrHeaders,
            withCredentials: false,
            bufferSizeLimit: 16 * 1024 * 1024,
            silentTimeout: 120000,
        },
    );

    currentConnectionKey = connectionKey;

    const onSignalHandler = (event) => {
        if (typeof onSignal === 'function') {
            onSignal(event);
        }
    };

    eventSource.__onSignal = onSignalHandler;
    eventSource.addEventListener('ping', onPing);
    eventSource.addEventListener('signal', onSignalHandler);

    return eventSource;
};

export { closeNotificationEventSource, openNotificationEventSource };
